import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  { n: "01", title: "IBAN- & Abschlagsänderung" },
  { n: "02", title: "WhatsApp & OCR" },
  { n: "03", title: "Rocket Home App", sub: "Neues Bestandskundenportal" },
  { n: "04", title: "Automatisierter Umzugsprozess" },
];

export function Slide17Roadmap(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Roadmap</div>
        <h1 className="deck-title rise rise-2">
          Was kommt <br />
          <span className="accent">als Nächstes</span>
        </h1>
      </header>

      <div className="deck-cols4">
        {TILES.map((t, i) => (
          <div key={t.n} className={`col-card rise rise-${(i % 3) + 4}`}>
            <div className="num">{t.n}</div>
            <h4>{t.title}</h4>
            {t.sub ? <p>{t.sub}</p> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
